/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationGenericTargets extends models.BillingRuleAllocation {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationGenericTargets");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationGenericTargets.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationGenericTargets>): BillingRuleAllocationGenericTargets {
        let obj = Object.assign(new BillingRuleAllocationGenericTargets(), model);
        BillingRuleAllocationGenericTargets.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationGenericTargets>): BillingRuleAllocationGenericTargets {
        if (!model) return null;
        return BillingRuleAllocationGenericTargets.newInstance(<BillingRuleAllocationGenericTargets> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationGenericTargets) {
        if (!obj) return;

        models.BillingRuleAllocationGenericTargets.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationGenericTargets): boolean {
        if (models.BillingRuleAllocation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationGenericTargets.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.targets) {
            for (let val of this.targets) {
                models.AllocationTarget.fixupPrototype(val);
            }
        }
    }

    /**
     * List of targets to allocate the cost to
     */
    targets: Array<models.AllocationTarget>;

}
